<ion-header>
  <ion-toolbar>
    <ion-title>Capacitor Tests</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="test-container">
    <h2>Native Plugin Tests</h2>
    <p>Platform: {{ platform }}</p>

    <ion-button expand="block" color="primary" (click)="runAllTests()">
      Run All Tests
    </ion-button>

    <div class="individual-tests">
      <h3>Individual Tests</h3>
      <ion-button expand="block" (click)="testPlatformInfo()">Platform Info</ion-button>
      <ion-button expand="block" (click)="testAppInfo()">App Info</ion-button>
      <ion-button expand="block" (click)="testStorage()">Storage</ion-button>
      <ion-button expand="block" (click)="testGeolocation()">Geolocation</ion-button>
      <ion-button expand="block" (click)="testCamera()">Camera (Gallery)</ion-button>
      <ion-button expand="block" (click)="testGallery()">Gallery</ion-button>
      <ion-button expand="block" (click)="testMultiplePhotos()">Multiple Photos</ion-button>
      <ion-button expand="block" (click)="testFilePicker()">File Picker</ion-button>
      <ion-button expand="block" (click)="testExifData()">EXIF Data</ion-button>
      <ion-button expand="block" (click)="testKeyboard()">Keyboard</ion-button>
      <ion-button expand="block" (click)="testBrowser()">Browser</ion-button>
      <ion-button expand="block" (click)="testSplashScreen()">Splash Screen</ion-button>
      <ion-button expand="block" (click)="testNotifications()">Notifications</ion-button>
      <ion-button expand="block" (click)="testVideoRecorder()">Video Recorder</ion-button>
    </div>

    @if (testResults.length > 0) {
      <ion-button expand="block" color="medium" (click)="clearResults()">
        Clear Results
      </ion-button>
    }

    @if (testResults.length > 0) {
      <div class="results">
        <h3>Test Results</h3>
        <ion-list>
          @for (result of testResults; track trackByResult($index, result)) {
            <ion-item>
              <ion-label>
                <h2>{{ result.test }}</h2>
                <p [class]="result.status">{{ result.status }}: {{ result.message }}</p>
              </ion-label>
            </ion-item>
          }
        </ion-list>
      </div>
    }
  </div>
</ion-content>
